import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
$("#nav3").addClass("active");
var swiper = new Swiper(".section4 .swiper", {
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
    },
    speed:1000,
    loop:true,
    navigation: {
        nextEl: '.section4 .swiper-button-next',
        prevEl: '.section4 .swiper-button-prev',
    },
    breakpoints: {
        320: { //当屏幕宽度大于等于320
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: '1%',
        },
        768: { //当屏幕宽度大于等于768 
            slidesPerView: 4,
            slidesPerGroup: 4,
            spaceBetween: '2.1%',
        },
        1280: { //当屏幕宽度大于等于1280
            slidesPerView: 5,
            slidesPerGroup: 5,
            spaceBetween: '2.1%',
        }
    },
});